// @flow

import React from "react";
import classNames from "classnames";
import { FormGroup, Label, TooltipDropdown, Icon, ComboBox } from "@components";

type Props = {
  schema: Object,
  uiSchema?: Object,
  formData?: Array<any>,
  rawErrors?: Array<string>,
  required?: boolean,
  disabled?: boolean,
  readonly?: boolean,
  className?: string,
  onChange: Function,
};

export function MultiSelectField(props: Props) {
  const schemaItems = props.schema?.items;
  const type = schemaItems?.type;
  const defaultItems = schemaItems?.oneOf || schemaItems?.properties?.id?.oneOf || [];
  const options = defaultItems.map(item => ({
    value: item.const,
    label: item.title,
  }));

  function selected() {
    if (!props.formData) {
      return [];
    }

    return props.formData.map(item => {
      const option = defaultItems.find(el =>
        type === "object" ? el.const === item.id : el.const === item,
      );
      return {
        value: option?.const || option,
        label: option?.title || option,
      };
    });
  }

  function handleChange(items: Array<Object>) {
    const selectedItems = items.map(item => {
      return type === "object" ? { id: item } : item;
    });

    props.onChange(selectedItems);
  }

  const disabledValue =
    selected()
      .map(item => String(item.label ?? ""))
      .join(", ") || "N/A";

  const label = props.schema.title || "";
  const tooltip = props.uiSchema && props.uiSchema["ui:options"]?.tooltip;

  return (
    <FormGroup
      className={classNames("mb-0 justify-content-center", {
        "field-error": props.rawErrors && props.rawErrors.length,
      })}
    >
      <div
        className={classNames("col col-xs-12 px-0", {
          "field-template-one-line": label.length <= 20,
          "field-template-two-line": label.length > 20,
        })}
      >
        <Label
          htmlFor={props.schema.title}
          className={classNames("field-template-label col-xs-12 font-weight-medium", {
            "d-flex align-items-center": !!tooltip,
          })}
        >
          <span>
            {label}
            {props.required ? (
              <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
            ) : null}
          </span>
          {tooltip && <TooltipDropdown {...tooltip} color="coffee" />}
        </Label>
      </div>
      <div className="col p-0">
        {props.disabled ? (
          <div className="schema-form-text-input">
            <input disabled className="form-control fs-14" value={disabledValue} />
          </div>
        ) : (
          <ComboBox
            isMulti
            onChange={handleChange}
            value={selected()}
            options={options}
            disabled={props.disabled}
            readOnly={props.readonly}
            id="multi-select"
            className={props.className}
          />
        )}
      </div>
    </FormGroup>
  );
}

export default MultiSelectField;
